export default "__VITE_ASSET__2SgabNdQ__"